<mat-toolbar class="w-full navbar-custom">
  <mat-toolbar-row class="bg-black flex justify-between h-full">
    <div class="text-white h-full flex items-center text-sm">
      <button routerLink="/" class="text-white flex items-center mr-5">
        <a routerLink="/" mat-button>
          <img
            src="assets/mazda_logo.png"
            alt="Home"
            width="30"
            height="18.75"
          />
        </a>
        TCMR3
      </button>

      <a
        *appPermission="this.userPrivileges[NavigationPoints.NSC]"
        routerLink="/organizations/nsc"
        routerLinkActive="active-link"
        mat-button
        class="navbar-item text-xs"
      >
        <span class="hover:text-gray-400 text-white">
          {{ 'NSC_PAGE.TITLE' | transloco }}
        </span>
      </a>

      <a
        *appPermission="this.userPrivileges[NavigationPoints.VEHICLE_ADMIN]"
        routerLink="/vehicle-admin"
        routerLinkActive="active-link"
        mat-button
        class="navbar-item hover:text-gray-400 text-xs"
      >
        <span class="hover:text-gray-400 text-white">
          {{ 'VEHICLE_ADMIN_PAGE.TITLE' | transloco }}
        </span>
      </a>
      <a
        *appPermission="this.userPrivileges[NavigationPoints.DEAL_ADMIN]"
        routerLink="/deal"
        routerLinkActive="active-link"
        mat-button
        class="navbar-item hover:text-gray-400 text-xs"
      >
        <span class="hover:text-gray-400 text-white">
          {{ 'DEAL_ADMIN_PAGE.TITLE' | transloco }}
        </span>
      </a>

      <a
        *appPermission="this.userPrivileges[NavigationPoints.BANK_ADMIN]"
        routerLink="/bank-admin"
        routerLinkActive="active-link"
        mat-button
        class="navbar-item hover:text-gray-400 text-xs"
      >
        <span class="hover:text-gray-400 text-white">
          {{ 'BANK_ADMIN_PAGE.TITLE' | transloco }}
        </span>
      </a>
      <a
        *appPermission="this.userPrivileges[NavigationPoints.DEALER_ADMIN]"
        routerLink="/dealer-admin"
        routerLinkActive="active-link"
        mat-button
        class="navbar-item hover:text-gray-400 text-xs"
      >
        <span class="hover:text-gray-400 text-white">
          {{ 'DEALER_ADMIN_PAGE.TITLE' | transloco }}
        </span>
      </a>
      <a
        *appPermission="this.userPrivileges[NavigationPoints.ACTIVITY_ADMIN]"
        routerLink="/activity-admin"
        routerLinkActive="active-link"
        mat-button
        class="navbar-item hover:text-gray-400 text-xs"
      >
        <span class="hover:text-gray-400 text-white">
          {{ 'ACTIVITY_ADMIN_PAGE.TITLE' | transloco }}
        </span>
      </a>

      <a
        *appPermission="
          this.userPrivileges[NavigationPoints.TDPP_REPORT_DATA_ADMIN]
        "
        routerLink="/tdpp-report-data-admin"
        routerLinkActive="active-link"
        mat-button
        class="navbar-item hover:text-gray-400 text-xs"
      >
        <span class="hover:text-gray-400 text-white">
          {{ 'TDPP_REPORT_DATA_ADMIN_PAGE.TITLE' | transloco }}
        </span>
      </a>
    </div>

    <div class="flex gap-2 text-white items-center h-full">
      <app-organization-selector class="h-full items-center flex" />

      <button
        mat-icon-button
        class="hover:rotate-90 transition ease-in hover:text-gray-400"
        [matMenuTriggerFor]="menu"
        [class]="currentRoute.startsWith('/settings') ? 'active-settings' : ''"
      >
        <mat-icon i18n>settings</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button
          *appPermission="privilege(Entity.LIST_OF_VALUE, Permissions.READ)"
          mat-menu-item
          routerLink="/settings/list-of-value"
        >
          {{ 'NAVBAR.LIST_OF_VALUES' | transloco }}
        </button>
        <button
          *appPermission="privilege(Entity.USER, Permissions.READ)"
          mat-menu-item
          routerLink="/settings/users"
        >
          {{ 'NAVBAR.USERS' | transloco }}
        </button>
        <button
          *appPermission="privilege(Entity.FILE, Permissions.READ)"
          mat-menu-item
          routerLink="/settings/file-handler"
        >
          {{ 'NAVBAR.FILES' | transloco }}
        </button>
        <button
          *appPermission="privilege(Entity.LOGIC_PROCESS, Permissions.READ)"
          mat-menu-item
          routerLink="/settings/logic-process"
        >
          {{ 'NAVBAR.LOGIC_PROCESS' | transloco }}
        </button>
        <button
          *appPermission="privilege(Entity.MAPPING, Permissions.READ)"
          mat-menu-item
          routerLink="/settings/mapping"
        >
          {{ 'NAVBAR.MAPPING' | transloco }}
        </button>
      </mat-menu>

      <app-auth-button />
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<div
  *ngIf="selectedOrganization$ | async as selectedOrg"
  class="p-6 content-custom"
>
  <router-outlet />
</div>
